import React from 'react';
import ArrowIcon from '@zola/zola-ui/src/components/SvgIcons/Arrow';
import { trackNavigationClicked } from '@zola/tracking-contracts/src/tracking';
import { transformNavigationLevel } from 'util/trackNavigationClickedHelpersV2';
import type {
  PrimaryNavItemType,
  PrimaryNavType,
  SecondaryNavItemType,
  SecondaryNavType,
} from '../../../preauthNavData';

import {
  Container,
  TitleSub,
  Link,
  liBaseStyles,
  SectionGroup,
  UnorderedList,
} from './MobileNavMenuLinkGroup.styles';

export type MobileNavMenuLinkGroupsProps = {
  menu: PrimaryNavType;
  menuItem: PrimaryNavItemType;
  menuItemIndex: number;
  subMenu: SecondaryNavType;
  className?: string;
};

const MobileNavMenuLinkGroupSub = ({
  menu,
  menuItem,
  menuItemIndex,
  subMenu,
  className,
}: MobileNavMenuLinkGroupsProps): JSX.Element => {
  const flattenedSubMenuItems = menuItem.subnav?.reduce(
    (items: SecondaryNavItemType[], subnavItem) => {
      if (subnavItem.items) {
        items.push(...subnavItem.items);
      }
      return items;
    },
    []
  );

  const handleTrackNavigationClicked = (subMenuItem: SecondaryNavItemType) => {
    trackNavigationClicked({
      business_category: subMenuItem.businessCategory || 'UNATTRIBUTED',
      business_unit: subMenuItem.businessUnit || 'UNATTRIBUTED',
      navigation_level_1: transformNavigationLevel(menu.title),
      navigation_level_1_position: menu.position,
      navigation_level_2: transformNavigationLevel(menuItem.label),
      navigation_level_2_position: menuItemIndex + 1,
      navigation_level_3: transformNavigationLevel(subMenuItem.label),
      navigation_level_3_position:
        (flattenedSubMenuItems?.findIndex((item) => item === subMenuItem) || 0) + 1,
      navigation_type: 'GLOBAL',
    });
  };

  return (
    <Container className={className}>
      {subMenu.map((group, groupIndex) => {
        return (
          <SectionGroup key={groupIndex}>
            {group.title && <TitleSub>{group.title}</TitleSub>}
            <UnorderedList>
              {group.items.map((itemGroup, itemGroupIndex) => {
                if (itemGroup.isDisabled) return null;
                return (
                  <li key={itemGroupIndex} css={liBaseStyles}>
                    <Link
                      target={itemGroup.target}
                      rel={itemGroup.rel}
                      href={itemGroup.path}
                      onClick={() => handleTrackNavigationClicked(itemGroup)}
                    >
                      {itemGroup.label}
                      {itemGroup.arrow && (
                        <ArrowIcon
                          flip="horizontal"
                          showTitle={false}
                          width={1.5}
                          height={-1}
                          unit="em"
                        />
                      )}
                    </Link>
                  </li>
                );
              })}
            </UnorderedList>
          </SectionGroup>
        );
      })}
    </Container>
  );
};

export default MobileNavMenuLinkGroupSub;
